import * as React from 'react';

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props.children);
};

export default FilterDropdownMenuWrapper;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/table/FilterDropdownMenuWrapper.js
// module id = 800
// module chunks = 0